<script setup lang="ts">
import { computed } from 'vue'
import { Form } from 'vee-validate'
import StepBasicInfoSchema from '@/schemas/StepBasicInfoSchema'
import StepBasicInfoFields from './StepBasicInfoFields.vue'
import type { ISensorFormData } from '@/interfaces/components/createSensor/create-sensor'
import { SensorType, translateSensorType } from '@/interfaces/enums'

const props = defineProps<{
  modelValue: ISensorFormData
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: ISensorFormData): void
  (e: 'validate', isValid: boolean): void
}>()

const typeOptions = Object.values(SensorType).map((type) => ({
  id: type,
  name: translateSensorType(type as SensorType),
}))

const manufacturerOptions = [
  { id: 'eng', name: 'eng' },
  { id: 'bin', name: 'bin' },
]

const initialValues = computed(() => ({
  sensor_type: typeOptions.find((o) => o.id === props.modelValue.sensor_type) ?? null,
  manufacturer: manufacturerOptions.find((o) => o.id === props.modelValue.manufacturer) ?? null,
}))
</script>

<template>
  <Form
    :validation-schema="StepBasicInfoSchema"
    :initial-values="initialValues"
    as="div"
    class="max-w-xl mx-auto w-full animate-fadeIn">
    <div class="text-center mb-10">
      <h2 class="text-2xl font-bold text-slate-900 dark:text-white">Tipo e Fabricante</h2>
      <p class="text-body text-slate-500 dark:text-gray-400 mt-1">Selecione o tipo de sensor e seu fabricante.</p>
    </div>

    <StepBasicInfoFields
      :model-value="modelValue"
      :type-options="typeOptions"
      :manufacturer-options="manufacturerOptions"
      :initial-values="initialValues"
      @update:model-value="emit('update:modelValue', $event)"
      @validate="emit('validate', $event)"
    />
  </Form>
</template>

<style scoped>
.animate-fadeIn { animation: fadeIn 0.4s ease-out; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>